module.exports = __webpack_public_path__ + "static/media/bgSolarPanelMorning.a48ea562.jpg";